<template>
	<AccordionList class="faq-accordion" :open-multiple-items="true">
		<AccordionItem v-for="(item, idx) in questions" :key="idx" class="faq-accordion__item" :defaultOpened="false">
			<template #summary>
				<div class="faq-accordion__item-summary">
					<h3>{{ item.question }}</h3>
				</div>
			</template>
			<template #icon><GlobalIcon name="arrow-up" :width="isMobile_lg ? 24 : 32" :height="isMobile_lg ? 24 : 32" /></template>
			<p class="faq-accordion__item-description">{{ item.answer }}</p>
		</AccordionItem>
	</AccordionList>
</template>

<script setup lang="ts">
// @ts-ignore "no types"
import { AccordionList, AccordionItem } from 'vue3-rich-accordion'

const { isMobile_lg } = useWindowWidth()

defineProps<{
	questions: IFaqQuestion[]
}>()
</script>

<style lang="scss">
@use '@/assets/scss/components/accordion';
</style>
<style lang="scss" scoped src="./FaqAccordion.scss"></style>
